import { Sidebar } from '@side/pantry';
import NextLink from 'next/link';
import { Spinner } from '@/components/Spinner';

export function SideBarSkeleton() {
  return (
    <Sidebar
      linkComponent={NextLink}
      TransactionStatusDropdownProps={{
        statuses: [],
        value: '',
        disabled: true,
      }}
    >
      <Spinner centered sx={{ height: '400px' }} />
    </Sidebar>
  );
}
